<template>
  <div v-if="isMaxScreen">
    <AppHead></AppHead>

    <div class="pc_pre-price">
      <div style="flex: 1; overflow-y: auto; height: 100%">
        <step></step>
        <!-- <PC-order-step></PC-order-step> -->
        <!-- <PC-bread-nav></PC-bread-nav> -->
        <div class="device-main">
          <div class="device-item">
            <PC-device-info :data="evaluationInfo"></PC-device-info>
            <PC-user-info
              :info="info"
              :nationCode="nationCode"
              @completeData="completeData"
            ></PC-user-info>
          </div>
        </div>
      </div>
    </div>
    <PC-bottom-button
      :disabled="!disabled"
      :data="evaluationInfo"
      :showSelect="true"
      :loading="loading"
      @handleSubmit="showDialog"
    ></PC-bottom-button>
    <el-dialog
      :title="$t('PCBottomButton.index.dialogTitle')"
      :visible.sync="centerDialogVisible"
      center
      class="pc_dialog"
      width="335px"
    >
      <span class="dialogText">{{ $t('PCBottomButton.index.dialogText') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="sureBtn" @click="pcSubmit">{{
          $t('PCBottomButton.index.dialogBtn')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="settle-account">
    <h-head></h-head>
    <step class="stepClass"></step>
    <PersonInfo ref="person" :info="info" @completePerson="completePerson"></PersonInfo>
    <AddressInfo
      ref="address"
      :info="info"
      :nationCode="nationCode"
      @completeAddress="completeAddress"
    ></AddressInfo>
    <BillInfo
      ref="bill"
      :info="info"
      :nationCode="nationCode"
      @completeBill="completeBill"
    ></BillInfo>

    <!-- <emailInfo ref="email" @completeEmail="completeEmail"></emailInfo> -->
    <!-- imei -->
    <!-- <div class="imei-info">
      <div class="title">Código IMEI (Nuevo dispositivo)</div>
      <div class="input-content">
        <input
          v-model="imei"
          type="number"
          class="input"
          placeholder="Please enter"
          oninput="if(value.length>15)value=value.slice(0,15)"
        />
        <div class="number">{{ imei ? imei.length : 0 }}/15</div>
      </div>
    </div>
    <ImeiPhoto ref="imei" @changeImeiPhoto="changeImeiPhoto"></ImeiPhoto> -->

    <van-dialog
      v-model="centerDialogVisible"
      :title="$t('PCBottomButton.index.dialogTitle')"
      :show-confirm-button="false"
      close-on-click-overlay
      class="h5_dialog"
    >
      <p>{{ $t('PCBottomButton.index.dialogText') }}</p>
      <div class="btn-box">
        <van-button class="btn2" @click="pcSubmit">{{
          $t('PCBottomButton.index.dialogBtn')
        }}</van-button>
      </div>
    </van-dialog>
    <footer>
      <div class="footer">
        <div class="bottom-select">
          <img
            v-if="select"
            src="@/assets/PC/img/select.png"
            alt=""
            class="selectIcon"
            @click="select = !select"
          />
          <img
            v-else
            src="@/assets/PC/img/unselect.png"
            alt=""
            class="selectIcon"
            @click="select = !select"
          />
          {{ $t('PCBottomButton.index.647hqss760c0') }}
          <span @click="goto(1)">&nbsp;{{ $t('PCBottomButton.index.647hqss764w0') }}</span> &
          <span @click="goto(2)">{{ $t('PCBottomButton.index.647hqss76ac0') }}</span>
        </div>
        <van-button
          :class="[disabled ? 'btn-active' : '', 'btn-photo']"
          :loading="loading"
          :loading-text="$t('PCUserInfo.index.submit')"
          loading-type="spinner"
          @click="showDialog"
          >{{ $t('PCUserInfo.index.submit') }}</van-button
        >
      </div>
    </footer>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import hHead from '@/components/layout/head.vue';
import PCBottomButton from '@/components/PCBottomButton';
import step from '@/components/step';
import { collected,collectUserInfo, evaluationCard } from '@/services/api/product';

import AppHead from '../../components/head/it-index.vue';
import CryptoFn from '../../utils/crypto';
import AddressInfo from './components/addressInfo.vue';
import BillInfo from './components/billInfo.vue';
import PCDeviceInfo from './components/PCDeviceInfo';
import PCUserInfo from './components/PCUserInfo';
import PersonInfo from './components/personInfo.vue';
export default {
  name: 'PersonalInfoPage',
  components: {
    PersonInfo,
    BillInfo,
    AddressInfo,
    AppHead,
    PCBottomButton,
    PCDeviceInfo,
    PCUserInfo,
    hHead,
    step
  },
  beforeRouteLeave(to, from, next) {
    const saveDataRoutes = ['/cookiePriva', '/termsAndConditions'];

    if (saveDataRoutes.includes(to.path)) {
      // 确保保存当前最新的数据
      this.$store.commit('setPageData', {
        ...this.info,
        isDownload: this.isDownload
      });
    } else if (!saveDataRoutes.includes(from.path)) {
      // 只有从非保存页面离开时才清除数据
      this.$store.commit('clearPageData');
    }

    next();
  },
  data() {
    return {
      evaluationInfo: {},
      info: {
        userName: '',
        mobile: '',
        countryCode: '',
        pinCode: '',
        city: '',
        address: '',
        bic: '',
        idCard: '',
        iban: '',
        mobileAreaCode: '',
        code: ''
      },
      imei: '',
      loading: false,
      isPersonInfoComplete: false,
      isBillInfoComplete: false,
      isAddressInfoComplete: false,
      isEmailComplete: false,
      disabled: false,
      select: false,
      centerDialogVisible: false,
      orderNum: '',
      evaluationId: '',
      subsidy: '',
      isDownload: false,
      nationCode: ''
    };
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  watch: {
    info: {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (!this.isMaxScreen) {
          const flag =
            this.isPersonInfoComplete &&
            this.isBillInfoComplete &&
            this.isAddressInfoComplete &&
            this.select;
          this.disabled = flag;
        }
      }
    },
    select(val) {
      if (!this.isMaxScreen) {
        this.disabled =
          this.isPersonInfoComplete && this.isBillInfoComplete && this.isAddressInfoComplete && val;
      }
    }
  },
  created() {
    this.orderNum = this.$route.query.orderNum;
    this.nationCode = this.$route.query.nationCode;
    this.evaluationId = this.$route.query.evaluationId;

    // 第一步：先从 Vuex 恢复数据
    this.restoreFromVuex();

    // 第二步：如果有 orderNum，调用 collected（会智能合并 API 数据）
    if (this.orderNum) {
      this.collected();
    } else if (this.evaluationId) {
      this.getProduct();
    }
  },
  methods: {
    collected() {
      collected({ orderNum: this.orderNum })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            if (data && data.mailNo) {
              this.$router.push({
                path: '/shippingLable',
                query: {
                  countryCode: data.countryCode,
                  mailNo: data.mailNo,
                  orderNum: this.orderNum,
                  token: this.$route.query.token,
                  nationCode: this.$route.query.nationCode
                }
              });
            } else {
              this.getProduct();
              // 合并数据：只有 API 字段有值时才覆盖
              this.mergeApiDataWithVuex(data);
            }
          }
        })
        .catch(err => {
        });
    },

    // 专门的数据合并方法 - 只合并非空字段
    mergeApiDataWithVuex(apiData) {
      if (apiData) {
        const fields = [
          'userName', 'mobile', 'countryCode', 'pinCode', 'city',
          'address', 'bic', 'idCard', 'iban', 'mobileAreaCode', 'code'
        ];

        fields.forEach(field => {
          // 只有当 API 数据字段有值（非空、非undefined、非null）时才覆盖
          if (this.hasValue(apiData[field])) {
            this.info[field] = apiData[field];
          }
        });
      }
    },

    // 判断值是否有意义的辅助方法
    hasValue(value) {
      return typeof value !== 'undefined' &&
             value !== null &&
             value !== '' &&
             !(typeof value === 'string' && value.trim() === '');
    },

    restoreFromVuex() {
      if (this.$store.state.pageData) {
        const pageData = this.$store.state.pageData;
        // 同样，只恢复 Vuex 中有值的字段
        Object.keys(this.info).forEach(key => {
          if (this.hasValue(pageData[key])) {
            this.info[key] = pageData[key];
          }
        });

        if (this.hasValue(pageData.isDownload)) {
          this.isDownload = pageData.isDownload;
        }
      }
    },

    getProduct() {
      evaluationCard({ evaluationId: this.evaluationId })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            this.evaluationInfo = data;
          }
        })
        .catch(err => {});
    },
    showDialog() {
      if (!this.isDownload) {
        // this.$toast('请下载诚信宣言');
        this.$toast(this.$t('components.successMain.downloadDec'));
        return;
      }
      if (!this.select && !this.isMaxScreen) {
        this.$toast(this.$t('component.tradeInProcess.toastTip'));
        return;
      }
      if (!this.disabled) {
        return;
      }
      this.centerDialogVisible = true;
    },
    goto(type) {
      if (type == 1) {
        this.$router.push({ name: 'cookiePriva' });
      } else {
        this.$router.push({ name: 'TermsAndConditions' });
      }
    },

    completePerson(data) {
      this.isPersonInfoComplete = data.flag;
      this.info = { ...this.info, ...data.form };
    },
    completeBill(data, isDownload) {
      this.isDownload = isDownload;
      this.isBillInfoComplete = data.flag && isDownload;
      this.info = { ...this.info, ...data.form };
    },
    completeAddress(data) {
      this.isAddressInfoComplete = data.flag;
      this.info = { ...this.info, ...data.form };
    },
    // completeEmail(data) {
    //   this.isEmailComplete = data.flag;
    //   this.info = { ...this.info, ...data.form };
    // },

    completeData(data, isDownload) {


      const {
        userName,
        mobile,
        idCard,
        countryCode,
        pinCode,
        city,
        address,
        iban,
        mobileAreaCode,
        bic // 新增 BIC 字段判断
      } = data;
      this.info = { ...data };

      this.isDownload = isDownload;

      // 基础必填字段
      const requiredFieldsFilled =
        userName && mobile && idCard && countryCode && pinCode && city && address && iban;

      // 如果是英国（GB），则必须填写 BIC
      const isGBAndBICFilled = this.nationCode === 'GB' ? Boolean(bic) : true;

      // 最终判断：所有必填字段 + 如果是英国则检查 BIC + 是否下载
      if (requiredFieldsFilled && isGBAndBICFilled && isDownload) {
        this.disabled = true; // 所有条件满足，禁用按钮
      } else {
        this.disabled = false; // 否则不禁用
      }
    },
    /**
     * 提交订单
     */
    async pcSubmit() {
      if (this.loading) {
        return;
      }

      const crypt = new CryptoFn();
      const maxRetries = 3;
      let retryCount = 0;
      let success = false;

      const {
        userName,
        mobile,
        pinCode,
        idCard,
        countryCode,
        city,
        address,
        iban,
        bic,
        mobileAreaCode
      } = this.info;

      const requestData = {
        orderNum: this.orderNum,
        userName,
        idCard,
        phone: mobileAreaCode + mobile,
        countryCode: countryCode,
        postCode: pinCode,
        city,
        address,
        iban: iban,
        bic: this.nationCode == 'GB' ? bic.replace(/-/g, '') : '',
        token: this.$route.query.token
      };

      const encryptedData = crypt.encrypt(JSON.stringify(requestData));
      this.centerDialogVisible = false;
      this.loading = true;

      while (retryCount < maxRetries && !success) {
        try {
          const res = await collectUserInfo({ data: encryptedData });
          if (res.code === '0000') {
            success = true;
            this.$router.push({
              path: '/shippingLable',
              query: {
                countryCode: countryCode,
                mailNo: res.data.mailNo,
                token: this.$route.query.token,
                orderNum: this.orderNum,
                nationCode: this.$route.query.nationCode
              }
            });
            return;
          }

          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        } catch (err) {
          retryCount++;
          if (retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        }
      }

      this.loading = false;
      const failMsg = this.$t('component.tradeInProcess.submitError');
      if (this.$toast) {
        this.$toast(failMsg);
      } else if (this.$message) {
        this.$message.error(failMsg);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@media (max-width: 981px) {
  .stepClass {
    margin-top: 88px;
  }

  .footer {
    display: flex;
    flex-direction: column;
  }
  .bottom-select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 50px;
    margin-bottom: 16px;
    img {
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
    span {
      color: #ff9600;
    }
  }
  .settle-account {
    background: #f4f5f7;
    padding: 24px;
    box-sizing: border-box;
    margin-bottom: 200px;
    .imei-info {
      width: 100%;
      box-sizing: border-box;
      color: #fff;
      margin-bottom: 24px;
      background: #fff;
      border-radius: 20px;
      padding: 0 24px;
      .title {
        height: 84px;
        font-size: 32px;
        font-weight: 500;
        color: #333;
        line-height: 84px;
      }
      .input-content {
        position: relative;
        .input {
          width: 100%;
          height: 92px;
          background: #f7f7f7;
          padding: 32px 24px;
          box-sizing: border-box;
          color: #333;
          font-size: 28px;
          border: none;
          border-radius: 12px;
          margin-bottom: 24px;
        }
        .number {
          position: absolute;
          top: 32px;
          right: 24px;
          font-size: 24px;
          color: #999;
        }
      }
    }
    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 999;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 10px 24px !important;
      font-size: 28px;
      .btn-photo {
        height: 80px;
        width: 100%;
        text-align: center;
        line-height: 80px;
        background: #ff8a14 !important;
        color: #fff !important;
        border-radius: 5px;
        opacity: 0.5;
        border-radius: 16px;
      }
      .btn-active {
        background: #ff8a14 !important;
        color: #fff !important;
        opacity: 1 !important;
      }
    }
    /deep/ .van-uploader__preview-delete {
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      border-radius: 12px;
    }
    /deep/ .van-uploader__preview-delete-icon {
      font-size: 20px;
      top: 0;
      right: 0;
    }
  }

  .h5_dialog {
    p {
      color: var(---Text-2, #5d5f65);
      font-family: 'PingFang SC';
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: 48px;
      margin: 32px 44px 52px;
    }

    .btn-box {
      display: flex;
      justify-content: space-between;
      margin: 32px 44px;
    }

    .btn1 {
      display: flex;
      flex: 1;
      height: 88px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      margin-right: 16px;
      border-radius: 10px;
      background: #f5f6f9;
      color: var(---Text-1, var(---Text-1, #252629));
      border: none;
    }
    .btn2 {
      display: flex;
      flex: 1;
      height: 88px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-radius: 10px;
      background: var(---Brand-1, #ff9600);
      color: #fff;
      border: none;
    }
  }
}

@media (min-width: 981px) {
  .pc_pre-price {
    background-color: #f8f8f8;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 1200px;
    margin: 100px auto 0;
    .device-main {
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      // margin-top: 24px;
      .device-item {
        width: 1200px;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .pc_dialog {
    .sureBtn {
      width: 287px;
      height: 44px;
      background: #ff9600;
      color: #fff;
      color: #fff;

      text-align: center;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 15.04px; /* 115.692% */
      border: none;
    }

    .dialogText {
      color: var(---Text-1, var(---Text-1, #252629));
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 157.143% */
      text-align: center;
      display: block;
    }

    /deep/.el-dialog__title {
      color: var(---Text-1, var(---Text-1, #252629));
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    /deep/.el-dialog__footer {
      padding-top: 0;
    }
    /deep/.el-dialog {
      border-radius: 8px;
    }
    /deep/.el-dialog__close {
      color: #000;
      font-weight: bold;
    }
  }
}
</style>